import { defineComponent as a, computed as o, openBlock as i, createElementBlock as r, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "73287168-b267-4420-8b98-6fb19b087945" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#73287168-b267-4420-8b98-6fb19b087945)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h167v512H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M345 0h167v512H345z"
}, null, -1), b = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ a({
  __name: "ml",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), r("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  z as default
};
//# sourceMappingURL=ml-5b9d0b6e.js.map
